export enum CouponType {
  PROPORTIONAL = 'proportional',
  FIXED = 'fixed',
}

export const couponTypeNameMap: Record<CouponType, string> = {
  [CouponType.PROPORTIONAL]: 'Yüzde',
  [CouponType.FIXED]: 'Sabit',
};
